var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInspection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3H18C19.6569 3 21 4.34315 21 6V22C21 23.6569 19.6569 25 18 25H4C2.34315 25 1 23.6569 1 22V6C1 4.34315 2.34315 3 4 3H8M14 3V3C14 1.89543 13.1046 1 12 1H10C8.89543 1 8 1.89543 8 3V3M14 3H8M5 15L10 19L17 9",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection);
export default __webpack_public_path__ + "static/media/Inspection.9db1262a80dea5ca678fc8a2961c24a0.svg";
export { ForwardRef as ReactComponent };